<template>
  <div class="ajax-input">
    <input ref="AjaxInputElement" type="text" @focusin="ajaxInputFocused=true" @focusout="setInputUnfocused"
           :class="cssClass?cssClass:'form-control'" :name="name || ''" v-model="currentValue"
           :placeholder="placeholder || ''"/>

    <div class="search-results" v-if="ajaxInputFocused && currentValue.length>2 && searchResults.length">
      <div class="result-item" @click="selectItem(item)" v-for="(item,index) in searchResults" :key="index">
        {{ item }}
      </div>
    </div>

  </div>
</template>

<script>
import jwtInterceptor from "@/shared/jwtInterceptor";

export default {
  name: "AjaxInput",
  data()
  {
    return {
      currentValue: '',
      itemTitle: 'title',
      dontSearch: false,
      ajaxInputFocused:false,
      searchResults: []
    }
  },
  mounted()
  {
    this.currentValue = this.value || '';
  },
  methods: {
    selectItem(value)
    {
      this.dontSearch = true;
      this.currentValue = value;
      this.$refs.AjaxInputElement.blur()
      this.ajaxInputFocused = false;
      setTimeout(() =>
      {
        this.dontSearch = false;
      }, 200)
      this.searchResults = [];
    },
    setInputUnfocused()
    {
      setTimeout(() =>
      {
        this.ajaxInputFocused = false;
        this.$emit('input', this.currentValue)
      }, 70)
    },
  },
  watch: {
    async currentValue()
    {
      this.$emit('keyup', this.currentValue)

      console.log('dontSearch', this.dontSearch)
      if (this.dontSearch)
        return;
      if (this.currentValue.length < 2)
      {
        this.searchResults = [];
        return;
      }
      let ch = '?';
      if (this.route.indexOf('?') >= 0)
        ch = '&'
      const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;
      const url = apiUrl + this.route + ch + 'q=' + this.currentValue;
      const result = await jwtInterceptor.get(url);
      const name = (this.resultTitle ? this.resultTitle : 'items')
      if (result && result.data && result.data.ok && result.data[name])
      {
        this.searchResults = result.data[name];
      }
    }
  },
  props: ['name', 'cssClass', 'placeholder', 'value', 'route', 'resultTitle']
}
</script>

<style scoped>

.search-results {
  position: absolute;
  z-index: 5;
  background: #fff;
  width: 100%;
  border-radius: 8px;
  margin-top: 6px;
  box-shadow: 0 0 5px 0;
  margin-right: 0;
  padding: 5px;
  max-height: 200px;
  overflow-y: auto;
}

.result-item {
  display: flex;
  border-bottom: 1px solid gainsboro;
  margin-bottom: 4px;
  padding-bottom: 8px;
  position: relative;
  padding-top: 5px;
}

.result-item:last-child {
  border-bottom: none;
}

.ajax-input {
  position: relative;
}
</style>